"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineSpeakerXMark } from "react-icons/hi2";
import { Button } from "@/components/ui";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useNotificationSound } from "@/hooks/use-notification-sound";
export function SoundBlockedBanner() {
  const $ = _c(9);
  const {
    soundPreference,
    canPlaySound,
    audioState,
    isLoaded,
    previewSound
  } = useNotificationSound();
  if (!isLoaded) {
    return null;
  }
  if (soundPreference === "none") {
    return null;
  }
  if (canPlaySound) {
    return null;
  }
  const unsupported = audioState === "unsupported";
  const message = unsupported ? "Notification sound isn't supported in this browser." : "Sound is blocked until you interact with the page.";
  let t0;
  if ($[0] !== message) {
    t0 = <AlertDescription className="flex-1">{message}</AlertDescription>;
    $[0] = message;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== previewSound || $[3] !== soundPreference || $[4] !== unsupported) {
    t1 = !unsupported && <Button size="sm" variant="primary" onClick={() => previewSound(soundPreference)}>Enable sound</Button>;
    $[2] = previewSound;
    $[3] = soundPreference;
    $[4] = unsupported;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <Alert variant="warning" icon={HiOutlineSpeakerXMark} className="rounded-none border-x-0 border-t-0 px-4 py-2.5"><div className="flex items-center gap-3">{t0}{t1}</div></Alert>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}